import imgPlaceHolder from "../../../../static_assets/img-placeholder.svg";

export const GrowthInfectionDefaultDataset = {
  langMap: [{ langCode: "en", name: "", description: "" }],
  image: imgPlaceHolder,
};

export const newlangTemplate = {
  langMap: { name: "", description: "" },
  image: imgPlaceHolder,
};
